/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-floating-promises */

import {CaretDownOutlined, CaretUpOutlined} from '@ant-design/icons';
import {Menu as MenuAnt, MenuProps} from 'antd';
import React, {useMemo, useState} from 'react';
import {
  Link,
  useLocation
  // useNavigate
} from 'react-router-dom';

import {ReactComponent as OM} from '../../assets/icons/Building_01.svg';
import {ReactComponent as Comms} from '../../assets/icons/Comms.svg';
// import {ReactComponent as Esg} from '../../assets/icons/Esg.svg';
import {ReactComponent as DataLineageIcon} from '../../assets/icons/data-lineage-dark.svg';
import {ReactComponent as Frameworks} from '../../assets/icons/Framework_icon.svg';
import {ReactComponent as Gap_analysis} from '../../assets/icons/Gap_Analytics.svg';
import {ReactComponent as NZM} from '../../assets/icons/NZM.svg';
import {ReactComponent as Peer_Benchmarking} from '../../assets/icons/Peer_Benchmarking.svg';
import {PermissionEnum} from '../../constants/permissionsEnum';
import {Routes, allRoutes, subRoutes} from '../../constants/Routes';
import TranslatedText from '../../libraries/I18N/TranslatedText';
import ProductLogos from '../../pages/HomeScreen/Components/ProductLogos';
// import {yearSelect} from '../../utils/FormUtils/yearSelect';
import {hasUserRole, UserRole} from '../../utils/commonFunctions';
import {removeSlash} from '../../utils/removeSlash';
import ESGFrameworkConfirmation from '../DisplayModal/ESGFramework/ESGFrameworkConfirmation';

import {checkIfHasPermissions, sideNavMapping} from './Utils/commonFunctions';

const ProductMenu: React.FC<{
  setOpenKeys: React.Dispatch<React.SetStateAction<string[]>>;
  setProduct: React.Dispatch<React.SetStateAction<string>>;
  openKeys: string[];
  product: string;
}> = ({setOpenKeys, openKeys, setProduct, product}) => {
  const location = useLocation();
  const [showEsgModal, setShowEsgModal] = useState(false);

  const nav = [
    {
      key: removeSlash(Routes.ORG_MANAGER),
      icon: <OM className="icon" />,
      label: <TranslatedText translationKey="ORG_MANAGER" />,
      route: Routes.ORG_MANAGER,
      // disabled: isNavDisabled(permissions?.OM),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManager),
      children: [
        // {
        //   key: removeSlash(subRoutes.orgManager),
        //   label: (
        //     <Link to={allRoutes.OM.orgManager}>
        //       <TranslatedText translationKey="ORG_PROFILE" />
        //     </Link>
        //   ),
        //   // disabled: isNavDisabled(permissions?.OM.orgManager),
        //   hidden: true
        // },
        // {
        //   key: removeSlash(subRoutes.facility),
        //   label: (
        //     <Link to={allRoutes.OM.facility}>
        //       <TranslatedText translationKey="FACILITY_OWNERSHIP" />
        //     </Link>
        //   ),
        //   hidden: true
        // },
        // {
        //   key: removeSlash(subRoutes.supplierInfo),
        //   label: (
        //     <Link to={allRoutes.OM.supplier}>
        //       <TranslatedText translationKey="Supplier Info" />
        //     </Link>
        //   ),
        //   hidden: true
        // },
        {
          key: removeSlash(subRoutes.infraProfile),
          label: (
            <Link to={allRoutes.OM.infraProfile}>
              <TranslatedText translationKey="ORG_INFRA_PROFILE" />
            </Link>
          ),
          // disabled: isNavDisabled(permissions?.OM.infraProfile)
          hidden: !checkIfHasPermissions(
            PermissionEnum.OrgManagerInfrastructureProfile
          )
        },
        {
          key: removeSlash(subRoutes.assetManagement),
          label: (
            <Link to={allRoutes.OM.assetManagement}>
              <TranslatedText translationKey="ASSET_MANAGER" />
            </Link>
          ),
          // disabled: isNavDisabled(permissions?.OM.assetManagement),
          hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerAssetManager)
        },
        {
          key: removeSlash(subRoutes.investments),
          label: (
            <Link to={allRoutes.OM.investments}>
              <TranslatedText translationKey="INVESTMENT" />
            </Link>
          ),
          // disabled: isNavDisabled(permissions?.OM.investments),
          hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerInvestment)
        },
        {
          key: removeSlash(subRoutes.products),
          label: (
            <Link to={allRoutes.OM.products}>
              <TranslatedText translationKey="PRODUCT" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerProduct)
        }
      ]
    },
    {
      key: removeSlash(Routes.NET_ZERO),
      icon: <NZM className="icon" />,
      label: <TranslatedText translationKey="NZM" />,
      route: Routes.NET_ZERO,
      // disabled: isNavDisabled(permissions?.NZM),
      hidden: !checkIfHasPermissions(PermissionEnum.NZM),
      children: [
        {
          key: removeSlash(subRoutes.nzmGeneral),
          label: (
            <Link to={allRoutes.NZM.generalized}>
              <TranslatedText translationKey="Generalized" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMGeneralized)
        },
        {
          key: removeSlash(subRoutes.nzmUtilities),
          label: (
            <Link to={allRoutes.NZM.utilities}>
              <TranslatedText translationKey="Utilities" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMUtilities)
        },
        {
          key: removeSlash(subRoutes.nzmSC),
          label: (
            <Link to={allRoutes.NZM.supplyChain}>
              <TranslatedText translationKey="Supply Chain Transport" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMSupplyChain)
        },
        {
          key: removeSlash(subRoutes.nzmTravel),
          label: (
            <Link to={allRoutes.NZM.travel}>
              <TranslatedText translationKey="Travel" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMTravel)
        },
        // {
        //   key: removeSlash(subRoutes.nzmCG),
        //   label: <TranslatedText translationKey="Capital Goods" />,
        //   onClick: () => {
        //     navigate(`${allRoutes.NZM.capitalGoods}`);
        //   },
        //   disabled: true || isNavDisabled(permissions?.NZM.capitalGoods)
        // },
        // {
        //   key: removeSlash(subRoutes.nzmOA),
        //   label: <TranslatedText translationKey="Other Activity" />,
        //   onClick: () => {
        //     navigate(`${allRoutes.NZM.otherActivities}`);
        //   },
        //   disabled: true || isNavDisabled(permissions?.NZM.otherActivities)
        // },
        {
          key: removeSlash(subRoutes.nzmAM),
          label: (
            <Link to={allRoutes.NZM.asset}>
              <TranslatedText translationKey="Asset" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMAsset)
        },
        {
          key: removeSlash(subRoutes.nzmProduct),
          label: (
            <Link to={allRoutes.NZM.products}>
              <TranslatedText translationKey="Products" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMProducts)
        }
      ]
    },
    {
      key: removeSlash(Routes.DATA_LINEAGE),
      icon: <DataLineageIcon className="icon" />,
      label: (
        <Link to={allRoutes.DATA_LINEAGE.dataLineage}>
          <TranslatedText translationKey="DATA_LINEAGE" />
        </Link>
      ),
      route: Routes.DATA_LINEAGE,
      hidden:
        !hasUserRole(UserRole.Company_Admin) &&
        !checkIfHasPermissions(PermissionEnum.DataLineage)
    },
    // {
    //   key: removeSlash(Routes.ESG),
    //   icon: <Esg className="icon" />,
    //   label: <TranslatedText translationKey="ESG_REPORTING" />,
    //   route: Routes.ESG,
    //   hidden: !checkIfHasPermissions(PermissionEnum.ESG),
    //   onClick: () => {
    //     // setShowEsgModal(true);
    //   }
    // },
    {
      key: removeSlash(subRoutes.framework),
      route: Routes.ESG,
      icon: <Frameworks className="icon" />,
      label: (
        <Link to={allRoutes.ESG.FRAMEWORK}>
          <TranslatedText translationKey="Frameworks" />
        </Link>
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.ESG)
    },
    {
      key: removeSlash(subRoutes.peer_bechmarking),
      route: Routes.ESG,
      icon: <Peer_Benchmarking className="icon" />,
      label: (
        <Link to={allRoutes.ESG.PEER_BENCHMARKING}>
          <TranslatedText translationKey="Peer Benchmarking" />
        </Link>
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.ESG)
    },
    {
      key: removeSlash(subRoutes.gap_analysis),
      route: Routes.ESG,
      icon: <Gap_analysis className="icon" />,
      label: (
        <Link to={allRoutes.ESG.GAP_ANALYSIS}>
          <TranslatedText translationKey="Gap Analysis" />
        </Link>
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.ESG)
    },

    // {
    //   key: removeSlash(Routes.STRATEGY),
    //   icon: (
    //     <TrophyOutlined
    //       className="icon"
    //       style={{fontSize: '200%', color: 'black'}}
    //     />
    //   ),
    //   label: <TranslatedText translationKey="Strategy" />,
    //   route: Routes.STRATEGY,
    //   disabled: false,
    //   onClick: () => {
    //     window.open(
    //       'https://www.figma.com/proto/Oc3NFRKsFuXXM7LjogllMh/Bharat-Carbon?page-id=340%3A22241&node-id=753-4710&node-type=FRAME&viewport=3287%2C1310%2C1&t=J6t4NBfpn5fwHtUi-1&scaling=contain&content-scaling=responsive&starting-point-node-id=753%3A4710&show-proto-sidebar=1',
    //       '_blank'
    //     );
    //   }
    // },
    {
      key: removeSlash(Routes.COMMS),
      icon: <Comms className="icon" />,
      label: <TranslatedText translationKey="COMMS_MANAGER" />,
      route: Routes.COMMS,
      hidden: true
    }
  ];

  const products = [
    {
      name: 'menu_item_product_carbon_accounting',
      title: 'Carbon Accounting',
      key: 'ca',
      icon: (
        <ProductLogos
          color={'#435B37'}
          product="CA"
          margin="0px 3px 3px -5px"
          width="32px"
          height="32px"
        />
      ),
      label: <TranslatedText translationKey="CARBON_ACCOUNTING" />,
      hidden: !(
        checkIfHasPermissions(PermissionEnum.Dashboard) ||
        checkIfHasPermissions(PermissionEnum.OrgManager) ||
        checkIfHasPermissions(PermissionEnum.NZM) ||
        checkIfHasPermissions(PermissionEnum.DataLineage) ||
        checkIfHasPermissions(PermissionEnum.AIDocumentManager)
      ),
      href: undefined
    },
    {
      name: 'menu_item_product_esg_reporting',
      title: 'ESG Reporting',
      key: 'esg',
      icon: (
        <ProductLogos
          color={'#435B37'}
          product="ESG"
          margin="0px 5px 3px -5px"
          width="32px"
          height="33px"
        />
      ),
      label: <TranslatedText translationKey="ESG_REPORTING" />,
      hidden: !checkIfHasPermissions(PermissionEnum.ESG),
      onClick: () => {
        // navigate(`ESG?selectedYear=${currentYear}`);
      },
      href: undefined
    },
    {
      name: 'menu_item_product_strategy',
      title: 'Strategy',
      key: 'strategy',
      icon: (
        <ProductLogos
          color={'#435B37'}
          product="Strategy"
          margin="0px 5px 3px -6px"
          width="32px"
          height="33px"
        />
      ),
      label: <TranslatedText translationKey="Net Zero Strategy" />,
      hidden: !checkIfHasPermissions(PermissionEnum.Strategy),
      onClick: () => {
        window.open(
          process.env.REACT_APP_STRATEGY_URL ??
            'https://dev-strategy.bharatcarbon.earth',
          '_blank'
        );
      }
    }
  ];

  const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
    const lastKey = keys[keys.length - 1];
    keys.shift();
    setOpenKeys(keys.length > 0 ? keys : [lastKey]);
  };

  const hideNavs = useMemo(() => {
    return sideNavMapping(nav, product);
  }, [product]);

  return (
    <>
      <div className="topMenuProduct" style={{marginTop: '10px'}}>
        <span className="menuTopTitle">
          {products.find((i) => i.key === product)?.title ?? 'Products'}
        </span>
        <div style={{overflowY: 'scroll', overflow: 'hidden'}}>
          <MenuAnt
            onClick={(e: any) => {
              if (e.key === 'strategy') {
                setProduct('');
              } else {
                if (
                  products.some((i) => {
                    return i.key === e.key;
                  })
                ) {
                  setProduct(e?.key);
                  localStorage.setItem('product', e?.key);
                }
              }
            }}
            mode="inline"
            items={
              product === '' ? products.filter((i) => !i.hidden) : hideNavs
            }
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            expandIcon={({isOpen}) => {
              return isOpen ? <CaretUpOutlined /> : <CaretDownOutlined />;
            }}
            selectedKeys={location.pathname.split('/')}
            className="menu"
            triggerSubMenuAction="click"
          />
        </div>
      </div>
      <ESGFrameworkConfirmation
        open={showEsgModal}
        onClose={() => {
          setShowEsgModal(false);
        }}
      />
    </>
  );
};

export default ProductMenu;
